// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { FormFilterOption } from "../schema";

export function serialize_FormFilterOption_internal(value: FormFilterOption): unknown {
  return ((value: { label: string; shortLabel: string | null; value: string }): unknown => {
    return {
      label: ((value: string): unknown => {
        return value;
      })(value["label"]),
      shortLabel: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["shortLabel"]),
      value: ((value: string): unknown => {
        return value;
      })(value["value"]),
    };
  })(value);
}
export function serialize_FormFilterOption(obj: FormFilterOption): string {
  return renderJsonWithNumbersAsBigint(serialize_FormFilterOption_internal(obj));
}
export function deserialize_FormFilterOption_internal(value: unknown): ParserResult<FormFilterOption> {
  return ((
    value: unknown,
  ): ParserResult<{
    label: string;
    shortLabel: string | null;
    value: string;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/FormFilterOption]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/FormFilterOption]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "label")) {
      return { success: false, reason: `[#/components/schemas/FormFilterOption/label]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'label'.` };
    }
    const parsed_label = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/FormFilterOption/label]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["label"]);
    })();
    if (!parsed_label.success) {
      return { success: false, reason: parsed_label.reason };
    }
    if (!hasProp(value, "shortLabel")) {
      return { success: false, reason: `[#/components/schemas/FormFilterOption/shortLabel]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'shortLabel'.` };
    }
    const parsed_shortLabel = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/FormFilterOption/shortLabel]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["shortLabel"]);
    })();
    if (!parsed_shortLabel.success) {
      return { success: false, reason: parsed_shortLabel.reason };
    }
    if (!hasProp(value, "value")) {
      return { success: false, reason: `[#/components/schemas/FormFilterOption/value]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'value'.` };
    }
    const parsed_value = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/FormFilterOption/value]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["value"]);
    })();
    if (!parsed_value.success) {
      return { success: false, reason: parsed_value.reason };
    }
    return { success: true, value: { label: parsed_label.value, shortLabel: parsed_shortLabel.value, value: parsed_value.value } };
  })(value);
}
export function deserialize_FormFilterOption(str: string): ParserResult<FormFilterOption> {
  return deserialize_FormFilterOption_internal(parseJsonWithNumbersAsBigint(str));
}
